<div class="legend-container" *ngIf="!!dataSource?.length">
  <div class="legend-item" (click)="filterByLegend('impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'impact drivers'">
    <div class="legend-color-box" style="background-color: #DCEAF7;"></div>
    <span>Impact drivers</span>
  </div>
  <div class="legend-item" (click)="filterByLegend('non-impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'non-impact drivers'">
    <div class="legend-color-box" style="background-color: #f2f2f2;"></div>
    <span>Non Impact drivers</span>
  </div>
</div>
<div class="card  table-wrapper">
  <div class="table-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>



  <div [ngClass]="{'table-container': !data?.isPagination, 'freeze-column-enabled': data?.freezeColumn}" *ngIf="!!dataSource?.length">
    <table mat-table [dataSource]="data?.isPagination ? pagedData : dataSource">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th class="tableheader" mat-header-cell *matHeaderCellDef
            [class.frozen-col]="isFrozenColumn(column)"
            [class.frozen-col-last]="isLastFrozenColumn(column)"
            [class.no-freeze-row]="data?.freezeRow === false"
            [class.collapsed-col-header]="isColumnCollapsed(column)"
            [style.left.px]="getFrozenColumnLeft(column)"
            (click)="isColumnCollapsed(column) ? toggleColumnCollapse(column, $event) : null">
          <div class="header-content" *ngIf="!isColumnCollapsed(column)">
            <span class="header-label">{{ columnLabels[column] }}</span>
            <span class="collapse-col-toggle"
              (click)="toggleColumnCollapse(column, $event)"
              title="Collapse column">&#9664;</span>
          </div>
          <span class="collapsed-col-label" *ngIf="isColumnCollapsed(column)"
            [title]="'Expand ' + columnLabels[column]">{{ columnLabels[column] }}</span>
        </th>
        <td class="tablebody" mat-cell *matCellDef="let row"
            [class.frozen-col]="isFrozenColumn(column)"
            [class.frozen-col-last]="isLastFrozenColumn(column)"
            [class.collapsed-col-cell]="isColumnCollapsed(column)"
            [style.left.px]="getFrozenColumnLeft(column)">
          <span *ngIf="!isColumnCollapsed(column)">{{ row[column] }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
        [style.--frozen-row-top.px]="getFrozenBodyRowTop(i)"
        [style.--frozen-row-bottom.px]="getFrozenBodyRowBottom(i)"
        [ngClass]="{
      'frozen-body-row': isFrozenBodyRow(i),
      'common-background': row.option_impact_drivers?.toLowerCase() === 'impact drivers',
      'non-common-background': row.option_impact_drivers?.toLowerCase() === 'non-impact drivers'
    }">
      </tr>

    </table>
    @if (!!data?.isPagination && !!dataSource.length ) {
    <app-paginator (pageChange)="onPageChange($event)" #paginatorComp></app-paginator>
    }
  </div>
</div>
